export default {
  state: [],

  mutations: {
    addContact: (state, contact) => {
      if (!(state.contact || []).some(c => c.id === contact.id)) {
        state.contact.push(contact)
      }
    },

    removeContact: (state, contactId) => {
      state.contact = state.contact.filter(c => c.id !== contactId)
    },

    removeAllContacts: (state, _) => state.contact = []
  },

  getters: {
    hasContact: state => {
      return (state.contact.length > 0)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/storeContact.js